<div class="card mt-12 bg-white">
  <div class="card-body">
    <form [formGroup]="form" (submit)="submit()">
      <fieldset class="fieldset">
        <legend class="fieldset-legend">
          {{ "settings.change-password.new-password" | translate }}
        </legend>

        <input
          type="password"
          [formControl]="newPassword"
          placeholder="{{
            'settings.change-password.new-password' | translate
          }}"
          required
          class="input"
          autocomplete="new-password"
        />

        @if (newPassword.dirty && newPassword.hasError("passwordComplexity")) {
          <p class="text-error label">
            {{
              "settings.change-password.password-complexity.error" | translate
            }}
          </p>

          <ol class="text-error">
            @if (
              newPassword.errors &&
              newPassword.errors["passwordComplexity"] &&
              newPassword.errors["passwordComplexity"].minLength
            ) {
              <li>
                {{
                  "settings.change-password.password-complexity.length"
                    | translate: { length: passwordComplexity.length }
                }}
              </li>
            }
            @if (
              newPassword.errors &&
              newPassword.errors["passwordComplexity"] &&
              newPassword.errors["passwordComplexity"].requiredCapitalLetters
            ) {
              <li>
                {{
                  "settings.change-password.password-complexity.required-capital-letters"
                    | translate
                      : {
                          requiredCapitalLetters:
                            passwordComplexity.requiredCapitalLetters
                        }
                }}
              </li>
            }

            @if (
              newPassword.errors &&
              newPassword.errors["passwordComplexity"] &&
              newPassword.errors["passwordComplexity"].requiredSmallLetters
            ) {
              <li>
                {{
                  "settings.change-password.password-complexity.required-small-letters"
                    | translate
                      : {
                          requiredSmallLetters:
                            passwordComplexity.requiredSmallLetters
                        }
                }}
              </li>
            }
            @if (
              newPassword.errors &&
              newPassword.errors["passwordComplexity"] &&
              newPassword.errors["passwordComplexity"].requiredNumbers
            ) {
              <li>
                {{
                  "settings.change-password.password-complexity.required-numbers"
                    | translate
                      : {
                          requiredNumbers: passwordComplexity.requiredNumbers
                        }
                }}
              </li>
            }
            @if (
              newPassword.errors &&
              newPassword.errors["passwordComplexity"] &&
              newPassword.errors["passwordComplexity"].requiredSymbols
            ) {
              <li>
                {{
                  "settings.change-password.password-complexity.required-symbols"
                    | translate
                      : {
                          requiredSymbols: passwordComplexity.requiredSymbols
                        }
                }}
              </li>
            }
          </ol>
        }
      </fieldset>

      <fieldset class="fieldset">
        <legend class="fieldset-legend">
          {{ "settings.change-password.new-password-check" | translate }}
        </legend>
        <input
          type="password"
          [formControl]="newPasswordCheck"
          placeholder="{{
            'settings.change-password.new-password-check' | translate
          }}"
          required
          class="input"
        />
        @if (newPasswordCheck.dirty && newPasswordCheck.hasError("required")) {
          <p class="text-error label">
            {{ "settings.change-password.required" | translate }}
          </p>
        }
      </fieldset>

      @if (form.hasError("passwordMismatch")) {
        <p class="text-error">
          {{ "settings.change-password.password-mismatch" | translate }}
        </p>
      }

      <div class="mt-4">
        <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
          {{ "common.confirm" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
